import React, { Component, Fragment } from 'react'
import PullUpLoad from '../../compontents/pullUpLoad'
import { throttle, connectWebViewJavascriptBridge } from './../../assets/js/utils'
import request from './../../assets/js/request'
import './index.less'

class InviteRecord extends Component {
    constructor(props) {
        super(props)
        this.state = {
            inviteList: [],
            pageNum: 1,
            pageSize: 10,
            total: '--',
            isFixedTitle: false
        }

        // 上次请求是否返回
        this.isLastedRequestEnd = true

        // 业务线
        this.businessLines = ''
        // 事件码
        this.eventCode = ''

        // 列表表头
        this.title = ''
        // 表头距顶部距离
        this.titleOffsetTop = ''
    }

    UNSAFE_componentWillMount() {
        // 设置标题
        this.setTitle('邀请记录')

        // 初始化
        this.init()
    }

    componentDidMount() { }

    // 设置标题
    setTitle(title) {
        if (!title) return
        connectWebViewJavascriptBridge(JSBridge => {
            JSBridge.callHandler('gome_title', { title })
        })
        document.title = title
    }

    init() {
        const params = new URLSearchParams(window.location.search)
        this.businessLines = params.get('businessLines')
        this.eventCode = params.get('eventCode')
    }

    async getInviteList() {
        if (!this.isLastedRequestEnd) {
            return
        }
        this.isLastedRequestEnd = false
        const { pageNum, pageSize } = this.state
        const { data: { list, total } } = await request.get(
            '/gateway/v2/invite/getInviteeList',
            {
                params: {
                    pageNum: pageNum,
                    pageSize: pageSize,
                    businessLines: this.businessLines,
                    eventCode: this.eventCode
                }
            }
        )
        if (!list || list.length === 0) {
            this.refs.pullUpLoad.handleFinished()
            return
        }
        this.setState(
            state => {
                return {
                    inviteList: [...state.inviteList, ...list],
                    pageNum: state.pageNum + 1,
                    total: total
                }
            },
            () => {
                this.refs.pullUpLoad.handleLoaded()
                const { pageNum, total, inviteList } = this.state
                if (inviteList.length === total) {
                    this.refs.pullUpLoad.handleFinished()
                }
                // 第一次数据加载完成监听页面滚动
                if (pageNum === 2) {
                    const _throttle = throttle()
                    this.title = document.querySelector('.invite-group-header .box')
                    this.titleOffsetTop = this.title.offsetTop
                    window.addEventListener('scroll', e => {
                        _throttle(this.handleTitleFollow.bind(this, e), 10)
                    })
                }
            }
        )
        this.isLastedRequestEnd = true
    }

    /**
   * 监听页面滚动
   * @param {Object} e
   */
    handleTitleFollow(e) {
        const scrollY = window.scrollY
        if (scrollY >= this.titleOffsetTop) {
            this.title.classList.add('fixed')
        } else {
            this.title.classList.remove('fixed')
        }
    }

    filterEvent(text) {
        if (text === '交易非首投成功') {
            return '投资成功'
        } else if (text === '交易首投成功') {
            return '首投成功'
        } else {
            return text
        }
    }

    render() {
        const { total, isFixedTitle, inviteList } = this.state
        let activityLink = '/activity?pageId=20427'
        if (process.env.REACT_APP_NODE_ENV === 'production') {
            activityLink = 'https://m.gomefinance.com.cn/activity?pageId=3735'
        }
        return (
            <PullUpLoad
                ref="pullUpLoad"
                pullUpLoad={() => {
                    this.getInviteList()
                }}
                emptyTips="您还没有邀请记录哦"
                emptyBtnText="立即邀请好友"
                emptyJumpLink={activityLink}
            >
                <div className="invite-record">
                    {inviteList && inviteList.length > 0 && (
                        <Fragment>
                            <div className="invite-total">
                                <h3>
                                    {total}
                                    <span>人</span>
                                </h3>
                                <p>我邀请的好友</p>
                            </div>

                            <div className="invite-group">
                                <div className="invite-group-header">
                                    <div className={`box ${isFixedTitle ? 'fixed' : ''}`}>
                                        <div className="cell">状态/时间</div>
                                        <div>邀请好友</div>
                                    </div>
                                </div>
                                <div className="invite-group-body">
                                    {inviteList.map(({ businessLineName, eventStatus, inviteTime, inviteeName, inviteeMobile }) => {
                                        return (
                                            <div className="item" key={inviteeMobile}>
                                                <div className="item-content">
                                                    <p>
                                                        {eventStatus === '注册成功' ? '' : businessLineName} {this.filterEvent(eventStatus)}
                                                    </p>
                                                    <span>{inviteTime}</span>
                                                </div>
                                                <div className="frend">{inviteeName || inviteeMobile}</div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </Fragment>
                    )}
                </div>
            </PullUpLoad>
        )
    }
}

export default InviteRecord
